import Image from '@tiptap/extension-image'
import { mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { TASK_DESCRIPTION_FILE_ID_ATTR } from '../../lib/taskTrackerDescription.utils'
import TaskTrackerRichTextImageView from './TaskTrackerRichTextImageView'

const buildImageHtmlAttributes = (width: string | null | undefined) => {
  const normalizedWidth = width?.trim() || '100%'

  return {
    'data-width': normalizedWidth,
    style: `width: ${normalizedWidth}; max-width: 100%; height: auto;`,
  }
}

export const TaskTrackerRichTextImage = Image.extend({
  name: 'image',
  group: 'block',
  inline: false,
  atom: true,
  isolating: true,
  draggable: true,

  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      width: {
        default: '100%',
        parseHTML: (element) => {
          const dataWidth = element.getAttribute('data-width')?.trim()
          if (dataWidth) return dataWidth

          const styleWidth = element.style.width?.trim()
          if (styleWidth) return styleWidth

          const attrWidth = element.getAttribute('width')?.trim()
          if (attrWidth) {
            return attrWidth.includes('%') || attrWidth.includes('px')
              ? attrWidth
              : `${attrWidth}%`
          }

          return '100%'
        },
      },
      fileId: {
        default: null,
        parseHTML: (element) => element.getAttribute(TASK_DESCRIPTION_FILE_ID_ATTR),
        renderHTML: (attributes) => {
          const fileId = attributes.fileId
          if (fileId == null || fileId === '') return {}

          return {
            [TASK_DESCRIPTION_FILE_ID_ATTR]: String(fileId),
          }
        },
      },
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'img',
      mergeAttributes(
        HTMLAttributes,
        buildImageHtmlAttributes(node.attrs.width),
      ),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(TaskTrackerRichTextImageView)
  },
})
